import { useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ISetIsKeywordsActionShown, KeywordsListStore } from 'pages/keywords/store'
import { KeywordsListContext } from 'pages/keywords/context/keywordsListContext'
import { KeywordsListContent } from 'pages/keywords/pages/all/ui/KeywordsListContent'

type IKeywordsListProps = {
  setIsKeywordsActionShown: ISetIsKeywordsActionShown
}

export const KeywordsList = ({ setIsKeywordsActionShown }: IKeywordsListProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new KeywordsListStore(setIsKeywordsActionShown, entities))

  useEffect(() => {
    return store.dispose
  }, [])

  return (
    <KeywordsListContext.Provider value={store}>
      <KeywordsListContent />
    </KeywordsListContext.Provider>
  )
}
